import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetTask } from 'selectors/tasks';

import { useCanUser } from 'shared-hooks/permission';
import { debounce } from 'utils/index';
import { isTempId } from 'utils/helpers';

import IconNumber from 'icons/icon-number';

const debouncedChange = debounce((storyPoints, callback) => {
    callback(storyPoints);
}, 500);

const TaskStoryPoints = ({ id, storyPoints, createdBy, withIcon, onChange, t }) => {
    const isTemp = isTempId(id);
    const [value, setValue] = useState(storyPoints);

    const handleChange = useCallback(event => {
        setValue(event.target.value);

        if (onChange) {
            if (event.target.value === '') {
                debouncedChange(null, onChange);
            }

            const nextStoryPoints = parseFloat(event.target.value, 10);

            if (isNaN(nextStoryPoints)) {
                return;
            }

            debouncedChange(nextStoryPoints, onChange)
        }
    }, [onChange]);

    const handleKeyDown = event => {
        if (event.which === 13) {
            event.target.blur();
        }
    }

    const handleBlur = () => {
        if (isNaN(parseFloat(value, 10)) && value !== '') {
            setValue(storyPoints);
        }
    }

    const canEdit = useCanUser('editTask', [createdBy]) && !isTemp;

    useEffect(() => {
        setValue(storyPoints);
    }, [storyPoints]);

    return (
        <div className="meta-item">
            {
                withIcon ? (
                    <span className="meta-icon">
                        <IconNumber />
                    </span>
                ) : null
            }

            <input
                key={id}
                className={'meta-field' + (typeof storyPoints !== 'number' ? ' placeholder' : '')}
                type="number"
                value={value === null ? undefined : value}
                disabled={!canEdit}
                placeholder={canEdit ? t('Set') : ''}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
};

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);

        return {
            storyPoints: task?.story_points,
            createdBy: task?.created_by
        }
    }
}

export default connect(makeMapStateToProps)(withTranslation('common')(React.memo(TaskStoryPoints)));
